import { Component, OnInit } from '@angular/core';
import { SignupStateService } from '../../services/signup-state.service';

/**
 * Paso 6 (empresa): verificacion de identidad del representante legal.
 *
 * Presenta el tramo —que se pide, como tiene que salir la foto— y toma el
 * consentimiento de tratamiento de datos biometricos. Sin el consentimiento no
 * se habilita el boton.
 *
 * Antes esto eran dos pantallas seguidas: una informativa con los requisitos y
 * esta con las recomendaciones y el checkbox. Las dos eran de solo lectura y
 * decian lo mismo con otras palabras, asi que se fusionaron. Va inmediatamente
 * antes de la captura, que es la que consiente.
 */
@Component({
  selector: 'app-empresa-consent-step',
  templateUrl: './empresa-consent-step.component.html',
  styleUrls: ['./empresa-consent-step.component.sass'],
})
export class EmpresaConsentStepComponent implements OnInit {
  consentGiven = false;

  requisitos = [
    {
      icon: 'badge',
      title: 'RUT',
      desc: 'Documentacion que acredite su identidad vigente.',
    },
    {
      icon: 'photo_camera',
      title: 'Verificacion de identidad',
      desc: 'Documento (RUT) chileno vigente del representante legal, mas una selfie.',
    },
    {
      icon: 'visibility',
      title: 'Documentos legibles',
      desc: 'La informacion debe leerse con claridad, sin distorsion ni luz tenue.',
    },
    {
      icon: 'crop_free',
      title: 'Documento completo',
      desc: 'El documento debe verse entero, sin cortes y sobre una superficie clara.',
    },
  ];

  recomendaciones = [
    'Use el documento (RUT) chileno vigente del representante legal.',
    'Tome la imagen en un espacio bien iluminado.',
    'Preparese para tomarse una selfie.',
  ];

  constructor(public signupState: SignupStateService) {}

  ngOnInit(): void {
    // Restaurar el consentimiento si el usuario ya paso por aqui
    this.consentGiven = this.signupState.biometricConsent;
  }

  onConsentChange(event: Event): void {
    this.consentGiven = (event.target as HTMLInputElement).checked;
    this.signupState.setBiometricConsent(this.consentGiven);
  }

  async start(): Promise<void> {
    if (!this.consentGiven) return;

    this.signupState.setBiometricConsent(true);
    await this.signupState.nextStep();
  }

  async goBack(): Promise<void> {
    await this.signupState.prevStep();
  }
}
